<template>
  <svg viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" :stroke="color">
    <g fill="#3D83EE" stroke="#3D83EE">
      <g transform="rotate(1)">
        <path class="st0" d="M17.5,9V5.7c0-0.9-0.7-1.6-1.5-1.6c-0.9,0-1.5,0.7-1.5,1.6v2.7c0,1.6,1.2,3.8,1.2,3.8l3.4,6.6
	c1.4,2.6,1.2,4.6,1.2,4.6v3.6c0,2-1.6,3.6-3.6,3.6H15c-1.9-0.1-3.4-1.6-3.5-3.6V24c0-1,0.5-1.4,0.8-1.6c0.3-0.1,1.4-0.6,2.1-1v4.9
	c0,0.9,0.7,1.6,1.5,1.6c0.9,0,1.5-0.7,1.5-1.6v-3.3c0-1.6-1.2-3.9-1.2-3.9l-3.4-6.6c-1.3-2.5-1.2-4.5-1.2-4.5V5.3
	c0-2,1.6-3.8,3.6-3.8H17c1.9,0,3.5,1.8,3.5,3.8v1.1c0,1-0.5,1.4-0.8,1.6C19.4,8.1,18.3,8.6,17.5,9"/>
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 16 16"
            to="360 16 16"
            dur="1s"
            repeatCount="indefinite"/>
        </path>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'spinner',
    props: {
      color: {
        type: String,
        default: '#000'
      },
      height: {
        type: Number,
        default: 64
      },
      width: {
        type: Number,
        default: 64
      }
    }
  }
</script>
